import { memo, useState, useMemo } from "react";
import imageOnTheWay from "../../../../../public/assets/images/imageOnTheWay.webp";

const CfdImageSingle = ({ imageUrl = "", style }) => {
  const [hasError, setHasError] = useState(false);

  // Memoized final image source to avoid unnecessary re-renders
  const finalImageUrl = useMemo(() => {
    if (hasError || !imageUrl) return imageOnTheWay;

    const urlStr = String(imageUrl);
    if (urlStr.startsWith("//")) return `https:${urlStr}`;
    if (urlStr.startsWith("http")) return urlStr;
    if (urlStr.startsWith("www")) return `https://${urlStr}`;

    return `https:${urlStr}`;
  }, [imageUrl, hasError]);

  return (
    <img
      className="cover"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        ...style,
      }}
      src={finalImageUrl}
      onError={() => setHasError(true)}
      alt="Property"
    />
  );
};

export default memo(CfdImageSingle);
